"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TikTokCreativeChangeRequest = void 0;
var TikTokCreativeChangeRequest;
(function (TikTokCreativeChangeRequest) {
    let reason;
    (function (reason) {
        reason["LANGUAGE"] = "language";
        reason["FORMAT"] = "format";
        reason["DURATION"] = "duration";
        reason["DOS"] = "dos";
        reason["DONTS"] = "donts";
        reason["FIRM_RESTRICTIONS"] = "firm_restrictions";
        reason["TONE"] = "tone";
        reason["STYLE"] = "style";
        reason["CTA"] = "cta";
        reason["CTA_TIMING"] = "cta_timing";
        reason["TALKING_POINTS"] = "talking_points";
        reason["ASSET_USAGE"] = "asset_usage";
    })(reason = TikTokCreativeChangeRequest.reason || (TikTokCreativeChangeRequest.reason = {}));
})(TikTokCreativeChangeRequest = exports.TikTokCreativeChangeRequest || (exports.TikTokCreativeChangeRequest = {}));
